import React, { useEffect, useState, useRef, useMemo, useImperativeHandle } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { TABLE_DATA } from "util";

import update from "immutability-helper";

import Rows from "./DnDTables/DataTable";

import ModalPortal from "util/component/Modal";
import { Confirm } from "util/component/Modal/Modal";

import axios from 'util/axios';
import { useTranslation } from "react-i18next";

import { EditableDiv } from "util/component/Input";
import CustomTextAreaList from "./DnDTables/CustomTextAreaList";

const P_TYPE = "in";
const API = "/pcsCreate/retrieveParaInList";

const HeaderTarget = {
    inReceivingSite: "Receiving Site",
    inSendingSite: "Sending Site",
    inSetPoint: "Set Point",
    inTargetRange: "Target Range",
    inAcceptableRange: "Acceptable Range",
};

const TRIANGLE_RED = "rgb(248 79 49)";
const TRIANGLE_GREEN = "rgb(35 197 82)";
const TRIANGLE_GRAY = "rgb(235 230 230)";

const initialData = TABLE_DATA[P_TYPE]

const InTable = (props, _ref) => {
    const { t } = useTranslation(["page"]);
    const { so, sso, setso, onOpen, RevCmptCheckList, remarkList,updateRemarkList} = props;
    const [Hide, setHide] = useState(false);

    const [ModalOpen, SetModalOpen] = useState(false);
    const [remarkOpen, SetRemarkOpen] = useState(false);
    const [textValue, setTextValue] = useState();
    const [TData, setTData] = useState([]);
    const modalData = useRef({ modalType: null });
    const [Header, SetHeader] = useState(HeaderTarget);

    useImperativeHandle(_ref, () => ({
        getTableData: () => {
            return TData;
        },
        getHeaderData: () => {
            return Header;
        },

        initial: () => {
            setTData((TD) => []);
        },
        add: (code) => {
            axios
                .post(process.env.REACT_APP_API + API, {
                    macd: code,
                    disableYn: "N",
                })
                .then((Response) => {
                    const d = Response.data.data.result;
                    /*
                임시 삭제
                if(d.length > 10) {
                */
                    setTData((TP) =>
                        update(TP, {
                            $push: [[]],
                        })
                    );
                    modalData.current = { modalType: "add", origindata: d };
                    SetModalOpen(true);
                    /*
                임시 삭제
                } else {
                   addParam(d);
                }
                */
                })
                .catch((Error) => console.error(Error));
        },
        move: ({ dragIndex, hoverIndex }) => {
            setTData((TP) =>
                update(TP, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, TP[dragIndex]],
                    ],
                })
            );
        },
        remove: (idx) => {
            setTData((TP) =>
                update(TP, {
                    $splice: [[idx, 1]],
                })
            );
        },
        loadData: ({ data, header,isCopy }) => {
            let newVal = [];
            let tmparr;
            let tmp;
            let fidx;

            data.forEach((d, i) => {

                tmparr = [];
                d.forEach((dd, ii) => {
                    tmp = TABLE_DATA[P_TYPE];
                    Object.keys(dd).forEach((k) => {
                        fidx = tmp.findIndex((i) => i.name === k);
                        if (fidx > -1) {
                            tmp = update(tmp, {
                                [fidx]: { $merge: { value: dd[k] } },
                            });
                            // if (k === "unit" && dd?.unitType?.toString() === "1") {
                            //     tmp = update(tmp, {
                            //         [fidx]: { $merge: { type: "text" } },
                            //     });
                            // }
                        }
                        if (k === "rcvCritical") {
                            tmp = update(tmp, {
                                [fidx]: { $merge: { label: dd["rcvCriticalNm"] } },
                            });
                        }
                        if(isCopy === "Y" && k === "interfaceCode"){
                            tmp = update(tmp, {
                                [fidx]: { $merge: { value: ""} },
                            });
                        }
/*                        if(isCopy === "Y" && k === "uniqueCode"){
                            tmp = update(tmp, {
                                [fidx]: { $merge: { value: ""} },
                            });
                        }*/
                    });
                    tmparr = [...tmparr, ...[tmp]];
                });

                newVal = [...newVal, [...tmparr]];
            });
            setTData((d) => [...newVal]);
            SetHeader((d) => {
                let newData = {};
                Object.keys(HeaderTarget).forEach((i) => {
                    newData[i] = !!header?.[i] ? header?.[i] : HeaderTarget?.[i];
                });
                return newData;
            });
        },
        copy: (data) => {
            const findIdx = so.findIndex((i) => i.tempUniqCode === data.tempUniqCode);
            const target = JSON.parse(JSON.stringify(TData[findIdx]));
            target.forEach((e) => {
                const a = e.map((ee) => {
                    if (ee.name === "uniqueCode") ee.value = "";
                    if (ee.name === "interfaceCode") ee.value = "";
                });
            });

            setTData((d) =>
                update(d, {
                    $push: [target],
                })
            );
        },
        reset:(idx )=> {

            setTData((TP) =>
                update(TP, {
                    $splice: [
                        [idx, 1],
                        [idx, 0, [TABLE_DATA[P_TYPE]]],
                    ],
                })
            );
        }
    }));

    const updateRemarkListRow = (idx,data,type)  => {
        updateRemarkList(idx,data,type);
    };


    const onOpenWrapper = (vv, uniqueCode) => {
        onOpen(vv, uniqueCode, TData, "IN");
    };
    const HandleHide = () => {
        setHide(!Hide);
    };

    const addRow = (tempUniqCode) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === tempUniqCode);
        setTData((TP) =>
            update(TP, {
                [findIdx]: { $push: [TABLE_DATA[P_TYPE]] },
            })
        );
    };

    const changeRow = (code, idx, idx2, obj) => {

        let findIdx = so.findIndex((e) => e.tempUniqCode === code);
        if (obj.check === "hide") {
            if (obj.value === "") {
                obj.value = "TRUE";
            }
        }
        let setData = {
            [idx2]: { $merge: { ...obj } },
        };
        if (obj.other) {
            const pcodeIdx = TData[findIdx][idx].findIndex((e) => e.name === "paraCd");
            const pdescIdx = TData[findIdx][idx].findIndex((e) => e.name === "paraDesc");
            if (pcodeIdx > -1) {
                setData = {
                    ...setData,
                    [pcodeIdx]: { $merge: { value: obj.other.paraCd } },
                };
            }

            if (pdescIdx > -1) {
                setData = {
                    ...setData,
                    [pdescIdx]: { $merge: { value: obj.other.paraDesc } },
                };
            }
            
        }
        // if(obj.isUnit) {
        //     const unitIdx = TData[findIdx][idx].findIndex((e) => e.name === "unit");
        //     if (obj.unitType?.toString() === "1") {
        //         setData = {
        //             ...setData,
        //             [unitIdx]: { $merge: { type: "text", value: "" } },
        //         };
        //     } else {
        //         const defaultUnitType = initialData.find((e) => e.name === "unit");
        //         setData = {
        //             ...setData,
        //             [unitIdx]: { $merge: { type: defaultUnitType.type, value: obj.other?.unit } },
        //         };
        //     }
        // }

        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    [idx]: setData,
                },
            })
        );
    };

    const changeRemark = (uniqueCode,value,remarkCnt,oldValue) => {

        TData.forEach((soData, i) => {
            soData.forEach((row, ii) =>{
                row.forEach((data,iii)=>{
                    if(data.name === 'uniqueCode'  &&uniqueCode.findIndex((d) => d && d === data.value) !== -1){
                        let setData = {
                            [row.findIndex((d) => d.name ==='remark')]: { $merge: { ...value } },
                        };
                        setTData((TP) =>
                            update(TP, {
                                [i]: {
                                    [ii]: setData,
                                },
                            })
                        );
                    }else if(data.name === 'remark'  && uniqueCode.findIndex((d) => (d === undefined || d === '')) !== -1  && data.value === oldValue){
                        let setData = {
                            [iii]: { $merge: { ...value } },
                        };
                        setTData((TP) =>
                            update(TP, {
                                [i]: {
                                    [ii]: setData,
                                },
                            })
                        );
                    }

                })
            })
        })
        so.forEach((data,i) =>{

            if( uniqueCode.findIndex((d) => d && d === data.uniqueCode) !== -1) {
                setso({
                    type: P_TYPE,
                    data: value.value,
                    idx: i,
                })
            }else if( uniqueCode.findIndex((d) => d) === -1  && data.inRemark === oldValue){
                setso({
                    type: P_TYPE,
                    data: value.value,
                    idx: i,
                })
            }

        })

        /* */

    }

    const moveRow = (code, dragIndex, hoverIndex) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === code);
        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, TP[findIdx][dragIndex]],
                    ],
                },
            })
        );
    };

    const addParam = (d) => {
        let dd = [];
        let tmp;
        let tn;
        const target = ["paraCd", "paraDesc", "paraNm", "unit"];
        d.forEach((v, i) => {
            tmp = initialData;
            target.forEach((vv) => {
                tn = tmp.findIndex((fi) => fi.name === vv);
                tmp = update(tmp, { [tn]: { $merge: { value: v[vv] } } });
                // if (vv === "unit") {
                //     if (v?.unitType?.toString() === "1") {
                //         tmp = update(tmp, { [tn]: { $merge: { type: "text", value: "" } } });
                //     }
                // }
            });
            dd = update(dd, {
                $push: [tmp],
            });
        });
        setTData((TP) =>
            update(TP, {
                [TP.length - 1]: { $set: [...dd] },
            })
        );
    };

    const selectedParams = () => {
        const { origindata } = modalData.current;
        const d = [];
        window.document.querySelectorAll(".create_in_add_modal table tbody tr.active").forEach((e) => {
            d.push(origindata[e.dataset.num]);
        });

        if (d.length > 0) {
            addParam(d);
        }
    };

    const validParam = () => {
        return window.document.querySelectorAll(".create_in_add_modal table tbody tr.active").length > 0;
    };

    const modalRender = () => {
        if (!ModalOpen) modalData.current = { modalType: null };

        const { modalType } = modalData.current;
        if (modalType === "delete") {
            return (
                <Confirm onClose={() => SetModalOpen(false)} onConfirm={() => deleteRowConfirm()}>
                    <p>{t("delete")}</p>
                </Confirm>
            );
        } else {
            const { origindata } = modalData.current;
            return (
                <Confirm onClose={() => SetModalOpen(false)} onConfirm={selectedParams} valid={validParam}>
                    <div className="create_in_add_modal">
                        <table>
                            <thead>
                                <tr>
                                    <th>Select Operational Parameter Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {origindata?.map((od, i) => (
                                    <tr
                                        data-num={i}
                                        key={"createinaddmodal" + i}
                                        onClick={(e) => e.target.closest("tr").classList.toggle("active")}
                                    >
                                        <td>{od.paraDesc}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Confirm>
            );
        }
    };
    const modal = useMemo(modalRender, [ModalOpen]);

    const deleteRow = (code, index) => {
        modalData.current = { modalType: "delete", code, index };
        SetModalOpen(true);
    };
    const deleteRowConfirm = () => {
        const { code, index } = modalData.current;

        const findIdx = so.findIndex((e) => e.tempUniqCode === code);
        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    $splice: [[index, 1]],
                },
            })
        );
        SetModalOpen(false);
    };

    const copyRow = (code, index) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === code);
        const newArr = JSON.parse(JSON.stringify(TData[findIdx][index]));
        newArr.forEach((f) => {
            if (f.name === "uniqueCode") {
                f.value = "";
            }
            if (f.name === "interfaceCode") {
                f.value = "";
            }
        });
        setTData((TP) =>
            update(TP, {
                [findIdx]: { $push: [newArr] },
            })
        );
    };

    // urs 30 : Receving Data -> Sending Data 카피 기능
    const copyRev = (code, index) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === code);
        // [fidx]: { $merge: { value: dd[k] } }
        // dataTable 참조,
        let rcvStartIndex = 0;
        let merge = {};

        TData[findIdx][index].forEach(({ name }, i) => {

            if (name.match(/^rcv/) && name !== "rcvCopy" && name !== "rcvCritical" && rcvStartIndex < 1) {
                rcvStartIndex = i;
            }
            if (name.match(/^snd/) && name !== "sndCritical") {
                merge = { ...merge, [i]: { $merge: { value: TData[findIdx][index][rcvStartIndex]?.value } } };
                rcvStartIndex++;
            }
        });
        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    [index]: merge,
                },
            })
        );
    };

    const copySndToRcv = (code, index) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === code);
        // [fidx]: { $merge: { value: dd[k] } }
        // dataTable 참조,
        let sndStartIndex = TData[findIdx][index].length;
        let merge = {};

        for (let i = TData[findIdx][index].length-1; i >= 0  ; i-- ){
            if (TData[findIdx][index][i].name.match(/^snd/) && sndStartIndex === TData[findIdx][index].length) {
                sndStartIndex = i;
            }
            if (TData[findIdx][index][i].name.match(/^rcv/) && TData[findIdx][index][i].name !== "rcvCopy" && TData[findIdx][index][i].name !== "rcvCritical") {
                merge = { ...merge, [i]: { $merge: { value: TData[findIdx][index][sndStartIndex]?.value } } };
                sndStartIndex--;
            }
        }

        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    [index]: merge,
                },
            })
        );
    };
    const [ soIndex, setSoIndex] = useState(0);
    // urs 30 끝
    const remarkState = (e) => {
        //setTextValue(e.target.innerHTML);
        SetRemarkOpen(!remarkOpen);

    };
    const addClass = (e) =>{
        e.target.closest('td').classList.add('tdFocused');
    }
    const removeClass = (className) =>{
        document.querySelectorAll('.'+className).forEach(e =>{
            e.classList.remove(className)
        })
    }
    const renderFunc = () => {
        try {
            let _sso = so[sso];
            if (!!_sso.tempUniqCode) {
                let remark = _sso[P_TYPE + "Remark"];
                const reviewData = RevCmptCheckList.find(
                    (f) => f.uniqueCode === _sso.uniqueCode && f.celNm === P_TYPE + "Remark"
                );
                let bg = TRIANGLE_GRAY;
                if (reviewData?.cmptType) {
                    if (reviewData.cmptType === "R") bg = TRIANGLE_RED;
                    else bg = TRIANGLE_GREEN;
                }
                return (
                    <React.Fragment>
                        <tr>
                            <td colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length} className="name">
                                <div className={"namename"}>
                                    {_sso?.desc}
                                    {/* <div className={"code"}>{"(" + _sso?.seqCode + ")"}</div> */}
                                </div>
                            </td>
                            <td>
                                <input
                                    type="checkbox"
                                    name={remark}
                                    checked={remark !== "FALSE"}
                                    onChange={(e) => {
                                        setso({
                                            type: P_TYPE,
                                            data: e.target.checked ? "" : "FALSE",
                                            idx: sso,
                                        });
                                    }}
                                />
                            </td>
                        </tr>
                        {remark !== "FALSE" && (
                            <tr>
                                <td
                                    colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length +1}
                                    className="soremark"
                                    style={{ position: "relative" }}
                                >
                                    {_sso.uniqueCode && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: 10,
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    backgroundColor: bg,
                                                    top: 0,
                                                    right: 0,
                                                    width: 20,
                                                    height: 20,
                                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                }}
                                                onClick={() => onOpen({ name: P_TYPE + "Remark" }, _sso?.uniqueCode)}
                                            ></div>
                                        </div>
                                    )}

                                    <div
                                        onClick={(e)=>{remarkState(e);addClass(e);}}
                                        contentEditable={"inherit"}
                                        suppressContentEditableWarning={true}
                                        style={{ position: "relative",minHeight:"70%"}}
                                        onBlur={(e) => {
                                            setso({
                                                type: P_TYPE,
                                                data: e.target.innerText,
                                                idx: sso,
                                            });
                                        }}
                                    >
                                        {remark}
                                    </div>
                                    {remarkOpen &&
                                        <CustomTextAreaList
                                            key={"remarkIn" + _sso}
                                            data={remark}
                                            changed={(e) => {
                                                setso({
                                                    type: P_TYPE,
                                                    data: e.target.innerText,
                                                    idx: sso,
                                                });
                                                updateRemarkListRow(_sso.uniqueCode, e.target.innerText.toString().trim(), "in");
                                            }}
                                            optionChanged={(value) => {
                                                setso({
                                                    type: P_TYPE,
                                                    data: value,
                                                    idx: sso,
                                                });
                                                updateRemarkListRow(_sso.uniqueCode, value, "in");
                                            }}
                                            changeData={
                                                (uniqueCode, value,oldValue) => {
                                                    changeRemark(uniqueCode, value, sso,oldValue);
                                                    //updateRemarkListRow(uniqueCode,value.value,tableType);
                                                }}
                                            dataList={newRemarkList}
                                            updateListRow={updateRemarkListRow}
                                            setDataList={setNewRemarkList}
                                            openState={() =>{remarkState();removeClass('tdFocused');}}
                                            textValue={textValue}
                                            setTextValue={setTextValue}
                                        />
                                    }
                                </td>
                            </tr>
                        )}

                        {TData[sso].map((v, ii) => {
                            return (
                                <Rows
                                    api={API}
                                    code={_sso.tempUniqCode}
                                    PROCode={_sso.code}
                                    index={ii}
                                    rowData={v}
                                    copied={copyRow}
                                    moveRow={moveRow}
                                    changed={changeRow}
                                    deleted={deleteRow}
                                    key={"in" + ii}
                                    copyRev={copyRev}
                                    copySndToRcv={copySndToRcv}
                                    onOpen={onOpenWrapper}
                                    RevCmptCheckList={RevCmptCheckList}
                                    remarkList={newRemarkList}
                                    setRemarkList = {setNewRemarkList}
                                    changeRemark = {changeRemark}
                                    tableType={"in"}
                                    updateRemarkListRow={updateRemarkListRow}
                                    removeClass = {removeClass}
                                    // conlog={conlog}
                                />
                            );
                        })}
                        <tr className="add_param" onClick={() => addRow(_sso.tempUniqCode)}>
                            <td colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length +1}>+Add Parameter</td>
                        </tr>

                    </React.Fragment>
                );
            } else {
                const ret = so.map((k, i) => {
                    if (!!!k.code) {
                        return null;
                    }
                    try {
                        let chk = TData[i].filter((v) => {
                            let chk2 = v.find((c) => c.name === "hide");
                            return chk2.value !== "TRUE";
                        });
                        let remark = k[P_TYPE + "Remark"];

                        const reviewData = RevCmptCheckList.find(
                            (f) => f.uniqueCode === k.uniqueCode && f.celNm === P_TYPE + "Remark"
                        );
                        let bg = TRIANGLE_GRAY;
                        if (reviewData?.cmptType) {
                            if (reviewData.cmptType === "R") bg = TRIANGLE_RED;
                            else bg = TRIANGLE_GREEN;
                        }

                        return (
                            <React.Fragment key={i}>
                                <tr>
                                    <td colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length} className="name">
                                        <div className={"namename"}>
                                            {k.desc}
                                            {/* <div className={"code"}>
                                                    {"(" + k.seqCode + ")"}
                                                </div> */}
                                        </div>
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            name={remark}
                                            checked={remark !== "FALSE"}
                                            onChange={(e) => {
                                                setso({
                                                    type: P_TYPE,
                                                    data: e.target.checked ? "" : "FALSE",
                                                    idx: i,
                                                });
                                            }}
                                        />
                                    </td>
                                    {/*<td></td>*/}
                                </tr>
                                {remark !== "FALSE" && (
                                    <tr>
                                        <td
                                            colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length +1}
                                            className="soremark"
                                            style={{ position: "relative" }}
                                        >
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        zIndex: 10,
                                                        cursor: "pointer",
                                                        position: "absolute",
                                                        backgroundColor: bg,
                                                        top: 0,
                                                        right: 0,
                                                        width: 20,
                                                        height: 20,
                                                        transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                    }}
                                                    onClick={() => onOpen({ name: P_TYPE + "Remark" }, k.uniqueCode)}
                                                ></div>
                                            </div>
                                            <div
                                                onClick={(e)=>{remarkState(e); setSoIndex(i);addClass(e);}}
                                                contentEditable={"inherit"}
                                                suppressContentEditableWarning={true}
                                                onBlur={(e) => {
                                                    setso({
                                                        type: P_TYPE,
                                                        data: e.target.innerText,
                                                        idx: i,
                                                    });
                                                }}
                                                style={{ position: "relative",minHeight:"70%"}}
                                            >
                                                {remark}
                                            </div>
                                            {remarkOpen &&
                                                <CustomTextAreaList
                                                    data={remark}
                                                    key={"remarkIn" + i}
                                                    changed={(e) => {
                                                        setso({
                                                            type: P_TYPE,
                                                            data: e.target.innerText,
                                                            idx: soIndex,
                                                        });
                                                        updateRemarkListRow(k.uniqueCode, e.target.innerText.toString().trim(), "in");
                                                    }}
                                                    optionChanged={(value) => {
                                                        setso({
                                                            type: P_TYPE,
                                                            data: value,
                                                            idx: soIndex,
                                                        });
                                                        updateRemarkListRow(k.uniqueCode, value, "in");
                                                    }}
                                                    changeData={
                                                        (uniqueCode, value,oldValue) => {
                                                            changeRemark(uniqueCode, value, i,oldValue);
                                                            //updateRemarkListRow(uniqueCode,value.value,tableType);
                                                        }}
                                                    dataList={newRemarkList}
                                                    updateListRow={updateRemarkListRow}
                                                    setDataList={setNewRemarkList}
                                                    openState={() =>{remarkState();removeClass('tdFocused');}}
                                                    textValue={textValue}
                                                    setTextValue={setTextValue}
                                                />
                                            }
                                        </td>
                                    </tr>
                                )}
                                {!!TData &&
                                    TData[i].map((v, ii) => {
                                        return (
                                            <Rows
                                                api={API}
                                                code={k.tempUniqCode}
                                                PROCode={k.code}
                                                index={ii}
                                                rowData={v}
                                                copied={copyRow}
                                                moveRow={moveRow}
                                                changed={changeRow}
                                                deleted={deleteRow}
                                                key={"in" + ii}
                                                tableType={"in"}
                                                copyRev={copyRev}
                                                copySndToRcv={copySndToRcv}
                                                onOpen={onOpenWrapper}
                                                RevCmptCheckList={RevCmptCheckList}
                                                remarkList={newRemarkList}
                                                changeRemark = {changeRemark}
                                                setRemarkList = {setNewRemarkList}
                                                updateRemarkListRow={updateRemarkListRow}
                                                removeClass = {removeClass}
                                            />
                                        );
                                    })}

                                {/* <tr className="add_param" onClick={() => addRow(k.tempUniqCode)}>
                                    <td colSpan={Object.keys(initialData).length + 1}>+Add Parameter</td>
                                </tr> */}
                            </React.Fragment>
                        );
                    } catch (e) {
                        console.error(e);
                        return null;
                    }
                });
                return ret;
            }
        } catch (e) {
            return null;
        }
    };

    const headerChange = (d, v) => {
        SetHeader((header) => ({
            ...header,
            [d.name]: v,
        }));
    };
    const [newRemarkList,setNewRemarkList] = useState({});
    useEffect(() => {
        //const t = newRemarkList?.filter(item => item.remark.includes(e.target.innerText.toString().trim()) );
        const tableRemarkList=remarkList.filter(item => item.name === "in");
        //const sortRemarkList=[...new Set(tableRemarkList.map( x =>x.remark))];
        let remarkData = [];
        tableRemarkList.sort().forEach((d,i) => {

            if (remarkData.findIndex((newData) => newData.value === d.value) === -1) {
                remarkData.push({value:d.value,oldValue:d.value,uniqueCode :[d.uniqueCode]});
            }else if(remarkData.findIndex((newData) => newData.value === d.value && newData.uniqueCode !== d.uniqueCode) !== -1){
               // remarkData = [remarkData,]
                remarkData.forEach((data,i) => {
                    if(data.value === d.value){
                        data.uniqueCode.push(d.uniqueCode);
                    }

                })
            }



        });
        so.forEach((d,i) => {
            if (remarkData.findIndex((newData) => newData.value === d.inRemark ) === -1 && d.inRemark !== "FALSE" && d.inRemark) {

                remarkData.push({value:d.inRemark,oldValue:d.inRemark,uniqueCode :[d.uniqueCode]});
            }else if(remarkData.findIndex((newData) => newData.value === d.inRemark && newData.uniqueCode !== d.uniqueCode ) !== -1 && d.inRemark !== "FALSE" && d.inRemark){
                remarkData.forEach((data,i) => {
                    if(data.value === d.inRemark){
                        data.uniqueCode.push(d.uniqueCode);
                    }

                })
            }
        })
        setNewRemarkList(remarkData);
    }, [remarkList]);

    return (
        <section className="create" style={{ width: "initial" }}>
            <div className={"in_table tbl_box " + (Hide ? "hide" : "")}>
                <h1 className={"title "} onClick={HandleHide}>
                Operational Parameter <FontAwesomeIcon icon={faAngleUp} />
                </h1>
                <div className={"data_table "}>
                    <DndProvider backend={HTML5Backend}>
                        <table>
                            <colgroup>
                                <col width="25"></col>
                                {/* paracd */}
                                {/* <col width="70"></col> */}
                                {/* para type */}
                                <col width="90"></col>
                                {/* para desc */}
                                <col width="80"></col>
                                {/* unit */}
                                <col width="40"></col>
                                {/* rcv critical */}
                                <col width="70"></col>
                                {/* rcv setpoint */}
                                <col width="60"></col>
                                {/* rcv target  */}
                                <col width="25"></col>
                                <col width="35"></col>
                                <col width="25"></col>
                                <col width="35"></col>
                                {/* rcv acc */}
                                <col width="25"></col>
                                <col width="35"></col>
                                <col width="25"></col>
                                <col width="35"></col>
                                {/* copy */}
                                <col width="20"></col>
                                {/* snd critical */}
                                <col width="70"></col>
                                {/* snd setpoint */}
                                <col width="60"></col>
                                {/* snd target  */}
                                <col width="25"></col>
                                <col width="35"></col>
                                <col width="25"></col>
                                <col width="35"></col>
                                {/* snd acc */}
                                <col width="25"></col>
                                <col width="35"></col>
                                <col width="25"></col>
                                <col width="35"></col>
                                {/* reference */}
                                <col width="120"></col>
                                {/* remark */}
                                <col width="30"></col>
                                {/* hide */}
                                {/*<col width="30"></col>*/}
                                {/* Remove Button */}
                                <col width="20"></col>
                            </colgroup>
                            <thead>
                                <tr>
                                    <th rowSpan="3"></th>
                                    {/* <th rowSpan="3">Parameter Code</th> */}
                                    <th rowSpan="3">Parameter Type</th>
                                    <th rowSpan="3">Parameter Description</th>
                                    <th rowSpan="3">Unit</th>
                                    <th colSpan="10">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "inReceivingSite",
                                                value: Header?.inReceivingSite || "",
                                            }}
                                        />
                                    </th>
                                    <th rowSpan="3"></th>
                                    <th colSpan="10">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "inSendingSite",
                                                value: Header?.inSendingSite || "",
                                            }}
                                        />
                                    </th>
                                    <th rowSpan="3">Reference</th>
                                    <th rowSpan="3">Remark</th>
                                    {/*<th rowSpan="3">Hide</th>*/}
                                </tr>

                                <tr>
                                    <th rowSpan="2">Criticality</th>
                                    <th rowSpan="2">Set point</th>
                                    <th colSpan="4">Target Range</th>
                                    <th colSpan="4">Acceptable range</th>
                                    <th rowSpan="2">Criticality</th>
                                    {/* URS 24번 추가 */}
                                    <th rowSpan="2">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "inSetPoint",
                                                value: Header?.inSetPoint || "",
                                            }}
                                        />
                                    </th>
                                    <th colSpan="4">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "inTargetRange",
                                                value: Header?.inTargetRange || "",
                                            }}
                                        />
                                    </th>
                                    <th colSpan="4">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "inAcceptableRange",
                                                value: Header?.inAcceptableRange || "",
                                            }}
                                        />
                                    </th>
                                    {/* URS 24번 추가 끝 */}
                                    {/* <th colSpan="4">Acceptable range</th> */}
                                </tr>

                                <tr>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                    {/* <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th> */}
                                </tr>
                            </thead>
                            <tbody>{renderFunc()}</tbody>
                            {/* <tfoot>
                            {
                                (!!so[sso] && !!so[sso]?.tempUniqCode) && <tr className="add_param" onClick={addRow}>
                                    <td colSpan={Object.keys(initialData).length + 1}>+Add Parameter</td>
                                </tr>
                            }
                        </tfoot> */}
                        </table>
                    </DndProvider>
                </div>
            </div>
            {ModalOpen && <ModalPortal>{modal}</ModalPortal>}
        </section>
    );
};

export default React.forwardRef(InTable);